const containerWidth = {
  backgroundColor: "white",
  width: "100%"
}

export default {
  containerWidth
}
